import api from './api'
import store from '../store/index'

// 대기 팀 수 조회
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792344125/API

// 대기 등록
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792802921/API
export function addWaiting (params) {
  const { restaurantIdx, waitingParams } = params
  return api.post(`/v1/restaurants/${restaurantIdx}/reservations`, waitingParams)
}

// 고객 요청사항 반환
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792999468/API
export function getRestaurantQuickMemo (restaurantIdx) {
  return api.get(`/v1/restaurants/${restaurantIdx}/quick-memo`)
}

// 메뉴 목록 반환
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1793523713/API
export function getMenuList (params) {
  const { restaurantIdx, numOfPeople, childCount } = params
  return api.get(`/v1/restaurants/${restaurantIdx}/orders/available-menus`, { params: { numOfPeople, childCount } })
}

// 매장 대기 팀수 반환
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792344125/API
export function getWaitingCount (restaurantIdx) {
  const toDay = new Date()
  const year = toDay.getFullYear()
  const month = toDay.getMonth() + 1
  const date = toDay.getDate()
  const requestedDate = `${year}-${month >= 10 ? month : '0' + month}-${date >= 10 ? date : '0' + date}`
  return api.get(`/v1/restaurants/${restaurantIdx}/reservations/count`, { params: { requestedDate } })
}

// 매장 상세정보 반환
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1793458177/API
export function getRestaurantInfo (restaurantIdx) {
  return api.get(`/v1/restaurants/${restaurantIdx}`)
}

// 매장 otp 번호 반환
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792999528/OTP+API
export function getOtpNumber (restaurantIdx) {
  return api.get(`/v1/restaurants/${restaurantIdx}/otp`)
}

// 주문메뉴 검증
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1796177955/API
export function validateOrderMenu (params) {
  const restaurantIdx = store.getters.getStoreIdx
  return api.post(`/v1/restaurants/${restaurantIdx}/orders/validate`, params)
}

// LINE 유저 정보를 받기 위한 임시키 발급 (LIFF 접근 주소 반환)
// https://mealantcloud.atlassian.net/browse/TB-14103
export function createLineTempKey (restaurantIdx) {
  return api.post(`/v1/line/restaurants/${restaurantIdx}/temp-keys`)
}
